import z from "zod";

export const envClientSchemaObj = {
  VITE_SENTRY_DSN: z.string().url(),
  VITE_SENTRY_TRACE_SAMPLE_RATE: z.coerce.number().default(1),
  VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE: z.coerce.number().default(0.1),
  VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE: z.coerce.number().default(0.5),
  VITE_SENTRY_REPLAY_MASK_ALL_TEXT: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("true"),
  VITE_SENTRY_REPLAY_MASK_ALL_INPUTS: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("true"),
  VITE_SENTRY_REPLAY_BLOCK_ALL_MEDIA: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("true"),
  VITE_API_BASE_URL: z.string().url(),
  VITE_API_BASE_URL_MOCK: z.string().url().optional().default('http://localhost:3000'),
  VITE_BASE_URL: z.string().url(),
  VITE_MANUAL_BOOK_URL: z.string().url(),
  VITE_SENTRY_ENVIRONMENT: z.string().default("development"),
  VITE_COOKIE_CONSENT: z.string().optional(),

  // Feature Flags
  VITE_FEATURE_FLAG_INVOICE_OI: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_INVOICE_OI_CMS_SUPPLIER_CONTRACT_CHECK: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("false"),
  VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL_CMS_SUPPLIER_CONTRACT_CHECK: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("false"),
  VITE_FEATURE_FLAG_INVOICE_NOI_INTERNAL: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_CONFIG: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_MASTER_DATA: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_SUPPLIER_PAGE: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_SUPPLIER_CONTRACT: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_IAM: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_TAX: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_RECEIPT_INVOICE: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_TWM: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_OTC: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_PAYMENT: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_DASHBOARD: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_BUDGET_PLAN_OPEX: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_BUDGET_PLAN_CAPEX: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_FILLING_SYSTEM: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_TAX_SYSTEM: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_TAX_SYSTEM_OUTGOING_LETTER_NUMBER_AUTO_GENERATE: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("false"),
  VITE_FEATURE_FLAG_UPLOAD_BUDGETING: z
    .enum(["true", "false"])
    .transform((value) => value === "true"),
  VITE_FEATURE_FLAG_TAX_MONITORING: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("true"),
    VITE_FEATURE_FLAG_MANAGEMENT_REPORT: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .default("true"),

  VITE_UPLOAD_LIMIT_OPEX_CAPEX: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_OI_NOI: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_TAX_MONITORING: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_TAX_SYSTEM: z.coerce.number().default(250),
  VITE_UPLOAD_LIMIT_MASTER_DATA: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_MANAGEMENT_REPORT: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_FILLING_SYSTEM: z.coerce.number().default(50),
  VITE_UPLOAD_LIMIT_OTC: z.coerce.number().default(50),
};
export const envClientCollectionObj = {
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_TRACE_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
  VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE: import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE: import.meta.env.VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE,
  VITE_SENTRY_REPLAY_MASK_ALL_TEXT: import.meta.env.VITE_SENTRY_REPLAY_MASK_ALL_TEXT,
  VITE_SENTRY_REPLAY_MASK_ALL_INPUTS: import.meta.env.VITE_SENTRY_REPLAY_MASK_ALL_INPUTS,
  VITE_SENTRY_REPLAY_BLOCK_ALL_MEDIA: import.meta.env.VITE_SENTRY_REPLAY_BLOCK_ALL_MEDIA,
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_API_BASE_URL_MOCK: import.meta.env.VITE_API_BASE_URL_MOCK,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
  VITE_MANUAL_BOOK_URL: import.meta.env.VITE_MANUAL_BOOK_URL,

  // Feature Flags
  VITE_FEATURE_FLAG_INVOICE_OI: import.meta.env.VITE_FEATURE_FLAG_INVOICE_OI,
  VITE_FEATURE_FLAG_INVOICE_OI_CMS_SUPPLIER_CONTRACT_CHECK:
    import.meta.env.VITE_FEATURE_FLAG_INVOICE_OI_CMS_SUPPLIER_CONTRACT_CHECK,
  VITE_FEATURE_FLAG_INVOICE_NOI_INTERNAL: import.meta.env.VITE_FEATURE_FLAG_INVOICE_NOI_INTERNAL,
  VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL: import.meta.env.VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL,
  VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL_CMS_SUPPLIER_CONTRACT_CHECK:
    import.meta.env
      .VITE_FEATURE_FLAG_INVOICE_NOI_EXTERNAL_CMS_SUPPLIER_CONTRACT_CHECK,
  VITE_FEATURE_FLAG_CONFIG: import.meta.env.VITE_FEATURE_FLAG_CONFIG,
  VITE_FEATURE_FLAG_MASTER_DATA: import.meta.env.VITE_FEATURE_FLAG_MASTER_DATA,
  VITE_FEATURE_FLAG_SUPPLIER_PAGE: import.meta.env.VITE_FEATURE_FLAG_SUPPLIER_PAGE,
  VITE_FEATURE_FLAG_SUPPLIER_CONTRACT: import.meta.env.VITE_FEATURE_FLAG_SUPPLIER_CONTRACT,
  VITE_FEATURE_FLAG_IAM: import.meta.env.VITE_FEATURE_FLAG_IAM,
  VITE_FEATURE_FLAG_TAX: import.meta.env.VITE_FEATURE_FLAG_TAX,
  VITE_FEATURE_FLAG_RECEIPT_INVOICE: import.meta.env.VITE_FEATURE_FLAG_RECEIPT_INVOICE,
  VITE_FEATURE_FLAG_TWM: import.meta.env.VITE_FEATURE_FLAG_TWM,
  VITE_FEATURE_FLAG_OTC: import.meta.env.VITE_FEATURE_FLAG_OTC,
  VITE_FEATURE_FLAG_PAYMENT: import.meta.env.VITE_FEATURE_FLAG_PAYMENT,
  VITE_FEATURE_FLAG_DASHBOARD: import.meta.env.VITE_FEATURE_FLAG_DASHBOARD,
  VITE_FEATURE_FLAG_BUDGET_PLAN_OPEX: import.meta.env.VITE_FEATURE_FLAG_BUDGET_PLAN_OPEX,
  VITE_FEATURE_FLAG_BUDGET_PLAN_CAPEX: import.meta.env.VITE_FEATURE_FLAG_BUDGET_PLAN_CAPEX,
  VITE_FEATURE_FLAG_FILLING_SYSTEM: import.meta.env.VITE_FEATURE_FLAG_FILLING_SYSTEM,
  VITE_FEATURE_FLAG_TAX_SYSTEM:
    import.meta.env.VITE_FEATURE_FLAG_TAX_SYSTEM,
  VITE_FEATURE_FLAG_TAX_SYSTEM_OUTGOING_LETTER_NUMBER_AUTO_GENERATE:
    import.meta.env.VITE_FEATURE_FLAG_TAX_SYSTEM_OUTGOING_LETTER_NUMBER_AUTO_GENERATE,
  VITE_FEATURE_FLAG_UPLOAD_BUDGETING:
    import.meta.env.VITE_FEATURE_FLAG_UPLOAD_BUDGETING,
  VITE_FEATURE_FLAG_TAX_MONITORING:
    import.meta.env.VITE_FEATURE_FLAG_TAX_MONITORING,
  VITE_FEATURE_FLAG_MANAGEMENT_REPORT:
    import.meta.env.VITE_FEATURE_FLAG_MANAGEMENT_REPORT,
  VITE_UPLOAD_LIMIT_OPEX_CAPEX: import.meta.env.VITE_UPLOAD_LIMIT_OPEX_CAPEX,
  VITE_UPLOAD_LIMIT_OI_NOI: import.meta.env.VITE_UPLOAD_LIMIT_OI_NOI,
  VITE_UPLOAD_LIMIT_TAX_MONITORING: import.meta.env.VITE_UPLOAD_LIMIT_TAX_MONITORING,
  VITE_UPLOAD_LIMIT_TAX_SYSTEM: import.meta.env.VITE_UPLOAD_LIMIT_TAX_SYSTEM,
  VITE_UPLOAD_LIMIT_MASTER_DATA: import.meta.env.VITE_UPLOAD_LIMIT_MASTER_DATA,
  VITE_UPLOAD_LIMIT_MANAGEMENT_REPORT: import.meta.env.VITE_UPLOAD_LIMIT_MANAGEMENT_REPORT,
  VITE_UPLOAD_LIMIT_FILLING_SYSTEM: import.meta.env.VITE_UPLOAD_LIMIT_FILLING_SYSTEM,
  VITE_UPLOAD_LIMIT_OTC: import.meta.env.VITE_UPLOAD_LIMIT_OTC,
};

export const envClientSchema = z.object(envClientSchemaObj);
export const envClient = envClientSchema.parse(envClientCollectionObj);
